import { render } from "./PendingBoxResolution.vue?vue&type=template&id=d6b46260"
import script from "./PendingBoxResolution.vue?vue&type=script&lang=js"
export * from "./PendingBoxResolution.vue?vue&type=script&lang=js"

import "./PendingBoxResolution.vue?vue&type=style&index=0&id=d6b46260&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__